import moment from 'moment';
import 'moment/locale/th';

export const formatDate = (date, format = 'DD/MMM/YYYY') => {
  const savedLang = JSON.parse(localStorage.getItem('language') || '{}');
  const lang = savedLang.initials?.toLowerCase() || 'en';
  var reqDate = date ?? new Date();
  return moment(reqDate).isValid()
    ? moment(reqDate).locale(lang).format(format)
    : '';
};

export const currentDateFormat = (format = 'DD/MMM/YYYY HH:mm') => {
  const savedLang = JSON.parse(localStorage.getItem('language') || '{}');
  const lang = savedLang.initials?.toLowerCase() || 'en';
  var date = new Date();

  return moment(date).locale(lang).format(format);
};

export const isValidTimeFormat = (time) => {
  return (
    moment(time, 'HH:mm:ss', true).isValid() ||
    moment(time, 'HH:mm', true).isValid()
  );
};

export const isValidDateTimeFormat = (date, time) => {
  return !date || !time;
};

export const convertToMinutesTimeFormat = (time) => {
  const totalMinutes = time;

  // Convert to hours and minutes
  const duration = moment.duration(totalMinutes, 'minutes');
  const hours = Math.floor(duration.asHours()); // Get total hours
  const minutes = duration.minutes(); // Get remaining minutes

  return time ? `${hours} h ${minutes} m` : '';
};

export const convertToTimeFormat = (timeStr) => {
  if (isValidTimeFormat(timeStr) || isNaN(parseInt(timeStr, 10))) {
    return timeStr;
  }

  if (timeStr.length == 1) {
    timeStr = '0' + timeStr;
  } else {
    var timeInt = parseInt(timeStr.substring(0, 2));
    timeStr = timeInt >= 24 ? '0' + timeStr : timeStr;
  }

  let paddedTimeStr;

  if (timeStr.length > 6) {
    paddedTimeStr = timeStr.substring(0, 6);
  } else {
    paddedTimeStr = timeStr.padEnd(6, '0');
  }

  const hours = paddedTimeStr.substring(0, paddedTimeStr.length - 4);
  const minutes = paddedTimeStr.substring(
    paddedTimeStr.length - 4,
    paddedTimeStr.length - 2
  );
  const seconds = paddedTimeStr.substring(paddedTimeStr.length - 2);

  const time = `${hours}:${minutes}:${seconds}`;

  return isValidTimeFormat(time) ? time : '00:00:00';
};

export const toPascalCase = (text) => {
  return text.replace(/(^\w|\s\w)/g, (txt) => txt.toUpperCase());
};

export const spacePascalCase = (text) => {
  if (!text) return;

  return text.replace(/([a-z])([A-Z])/g, '$1 $2');
};

export const dateFromNow = (date) => {
  const savedLang = JSON.parse(localStorage.getItem('language') || '{}');
  const lang = savedLang.initials?.toLowerCase() || 'en';

  return moment(date).isValid() ? moment(date).locale(lang).fromNow() : '';
};

export const humanReadableSize = (bytes) => {
  const units = ['B', 'KB', 'MB', 'GB', 'TB', 'PB'];
  let unitIndex = 0;

  while (bytes >= 1024 && unitIndex < units.length - 1) {
    bytes /= 1024;
    unitIndex++;
  }

  return `${Math.floor(bytes)} ${units[unitIndex]}`;
};

export const handleRipple = (event) => {
  const card = event.currentTarget;
  const ripple = document.createElement('span');

  const rect = card.getBoundingClientRect();
  const size = Math.max(rect.width, rect.height);
  ripple.style.width = ripple.style.height = `${size}px`;
  ripple.style.left = `${event.clientX - rect.left - size / 2}px`;
  ripple.style.top = `${event.clientY - rect.top - size / 2}px`;
  ripple.classList.add('ripple');

  card.appendChild(ripple);

  setTimeout(() => {
    ripple.remove();
  }, 600);
};

export function getDeviceType() {
  var user = JSON.parse(
    localStorage.getItem(`${process.env.VUE_APP_NAME}_user`)
  );

  if (user?.deviceType) return user?.deviceType;

  const ua = navigator.userAgent;
  if (/mobile/i.test(ua)) {
    return 'mobile';
  }
  if (/tablet/i.test(ua)) {
    return 'tablet';
  }

  return 'desktop';
}

export const convertToPascalCaseWithSpaces = (key) => {
  return key
    .replace(/([a-z])([A-Z])/g, '$1 $2')
    .replace(/^./, (str) => str.toUpperCase())
    .trim();
};

const formatDurationUnit = (
  count,
  singularKey,
  pluralKey,
  enSingular,
  enPlural,
  t
) => {
  if (t) {
    return `${t(count > 1 ? pluralKey : singularKey, { count })} `;
  }

  return `${count} ${count > 1 ? enPlural : enSingular} `;
};

export const renderDuration = (dur, t) => {
  if (dur.days === 0 && dur.hours === 0 && dur.minutes === 0) {
    return t ? `${t('common.durationZeroMinutes')} ` : '0 minutes ';
  }

  let duration = '';

  if (dur.days > 0) {
    duration += formatDurationUnit(
      dur.days,
      'common.durationDay',
      'common.durationDays',
      'day',
      'days',
      t
    );
  }

  if (dur.hours > 0) {
    duration += formatDurationUnit(
      dur.hours,
      'common.durationHour',
      'common.durationHours',
      'hour',
      'hours',
      t
    );
  }

  if (dur.minutes > 0) {
    duration += formatDurationUnit(
      dur.minutes,
      'common.durationMinute',
      'common.durationMinutes',
      'minute',
      'minutes',
      t
    );
  }

  return duration;
};

export function formatDateRange(date, range, typeDate, format = 'YYYYMMDD') {
  const type = typeDate; // Get the typeDate from the filter

  if (type == 1) {
    // Monthly
    if (typeof date === 'object' && 'year' in date && 'month' in date) {
      const { year, month } = date;

      if (range === 'start') {
        date = new Date(year, month, 1);
      } else {
        date = new Date(year, month + 1, 0); // last day of month
      }
    } else {
      const d = new Date(date);

      if (range === 'start') {
        // Set to 1st of the month
        date = new Date(d.getFullYear(), d.getMonth(), 1);
      } else {
        // Set to last day of the month
        date = new Date(d.getFullYear(), d.getMonth() + 1, 0);
      }
    }
  } else if (type == 2) {
    if (range === 'start') {
      date = new Date(date, 0, 1);
    } else {
      date = new Date(date, 11, 31);
    }
  }

  if (!moment.utc(date).isValid()) {
    return ''; // Return an empty string if the date is invalid
  }

  let momentDate = moment.utc(date).utcOffset('+0700');

  // Handle start and end based on the typeDate value
  if (range === 'start') {
    if (type === 1) {
      // Month to Month
      return momentDate.startOf('month').format(format); // Start of the month
    } else if (type === 2) {
      // Year to Year
      return momentDate.startOf('year').format(format); // Start of the year
    }
  } else if (range === 'end') {
    if (type === 1) {
      // Month to Month
      return momentDate.endOf('month').format(format); // End of the month
    } else if (type === 2) {
      // Year to Year
      return momentDate.endOf('year').format(format); // End of the year
    }
  }

  // If type is 0 (Date to Date), just format the given date
  return momentDate.format(format);
}

export const minutesToDhms = (minutes) => {
  if (minutes == null || isNaN(minutes)) return '-';

  const sign = minutes < 0 ? '-' : '';
  const dur = moment.duration(Math.abs(minutes), 'minutes');

  const days = Math.floor(dur.asDays());
  const hours = dur.hours();
  const mins = dur.minutes();

  const parts = [];
  if (days) parts.push(`${days}d`);
  if (hours) parts.push(`${hours}h`);
  // show minutes if non-zero, or if everything is zero → "0m"
  if (mins || (!days && !hours)) parts.push(`${mins}m`);

  return sign + parts.join(' ');
};

export const dateFormatFormType = (type) => {
  var format = '';
  switch (type) {
    case 0:
      format = 'dd/MM/yyyy';
      break;
    case 1:
      format = 'MM/yyyy';
      break;
    case 2:
      format = 'yyyy';
      break;
    default:
      break;
  }

  return format;
};

export function calcFullFormatDuration(period, t) {
  if (!period) {
    return t ? t('common.durationZeroMinutes') : '0 minutes';
  }

  const { startDate, startTime, endDate, endTime, allDay } = period;

  // 👉 ALL-DAY MODE: calculate days only
  if (allDay) {
    if (!startDate || !endDate) {
      return t ? t('common.durationZeroDays') : '0 days';
    }

    const start = new Date(startDate);
    const end = new Date(endDate);

    // normalize to midnight so time-of-day is ignored
    start.setUTCHours(0, 0, 0, 0);
    end.setUTCHours(0, 0, 0, 0);

    let diffMs = end - start;
    if (diffMs < 0) {
      return;
    }

    const dayMs = 24 * 60 * 60 * 1000;
    const days = Math.floor(diffMs / dayMs); // same semantics as your current diff

    // only days, no hours/minutes
    return renderDuration({ days: days + 1, hours: 0, minutes: 0 }, t);
  }

  // 👉 NORMAL MODE: days + hours + minutes
  if (!startDate || !startTime || !endDate || !endTime) {
    return t ? t('common.durationZeroMinutes') : '0 minutes';
  }

  const start = new Date(startDate);
  const end = new Date(endDate);

  // "HH:MM:SS" → numbers
  const [sH, sM, sS] = startTime.split(':').map(Number);
  const [eH, eM, eS] = endTime.split(':').map(Number);

  // Because your date string ends with Z, use UTC
  start.setUTCHours(sH, sM, sS || 0, 0);
  end.setUTCHours(eH, eM, eS || 0, 0);

  let diffMs = end - start;
  if (diffMs < 0) {
    return;
  }

  const diffSec = Math.floor(diffMs / 1000);

  return calcSectoFormatDuration(diffSec, t);
}

export function calcSectoFormatDuration(diffSec, t) {
  const daySec = 24 * 60 * 60;
  const hourSec = 60 * 60;
  const minuteSec = 60;

  const days = Math.floor(diffSec / daySec);
  let rest = diffSec % daySec;

  const hours = Math.floor(rest / hourSec);
  rest = rest % hourSec;

  const minutes = Math.floor(rest / minuteSec);

  return renderDuration({ days, hours, minutes }, t);
}

export function timetoHHMM(timeStr) {
  if (!timeStr) return '';

  const [h, m] = timeStr.split(':');
  return `${h}:${m}`;
}

// val = {Date, Time}
export function renderDateTimeFormat(val) {
  if (!val) return 'n/a';

  if (!val?.Date && !val?.Time) return 'n/a';

  try {
    var dateTime = val;
    if (dateTime.Date != null && dateTime.Time != null) {
      return `${formatDate(dateTime.Date)} ${dateTime.Time}`;
    } else if (dateTime.Date != null) {
      return formatDate(dateTime.Date);
    } else if (dateTime.Time != null) {
      return dateTime.Time;
    }
  } catch (e) {
    return 'n/a';
  }
}

export function getDateTimeRangeValue(data) {
  var startDate = data?.start_date
    ? formatDate(data?.start_date, 'DD/MMM/YYYY')
    : '';
  var startTime = data?.all_day ? '' : timetoHHMM(data?.start_time);

  var endDate = data?.end_date ? formatDate(data?.end_date, 'DD/MMM/YYYY') : '';
  var endTime = data?.all_day ? '' : timetoHHMM(data?.end_time);

  return `${startDate} ${startTime} - ${endDate} ${endTime}`;
}

export const toNumber = (v) => {
  if (v === null || v === undefined || v === '') return 0;

  if (typeof v === 'number') return Number.isFinite(v) ? v : 0;

  const s = String(v).trim().replace(/,/g, '');
  const n = Number(s);

  return Number.isFinite(n) ? n : 0;
};

export function renderMultipleDataName(field, ids, isShowSpan = false) {
  if (!ids) return;

  var fieldData = field.options.filter((x) => ids.includes(x.value));

  if (isShowSpan) {
    return fieldData.map((x) => `<span>${x.name_EN}</span>`).join(', <br>');
  } else {
  }
  return fieldData.map((x) => x.name_EN).join(', ');
}

export function handleNumberKeydown(event, value, options = {}) {
  if (event.key === '-') {
    event.preventDefault();
    return value;
  }

  if (event.key !== 'ArrowUp' && event.key !== 'ArrowDown') {
    return value;
  }

  event.preventDefault();

  const step = Number(options.step ?? 1);
  const min = Number(options.min ?? 0);
  const max =
    options.max === '' || options.max == null
      ? Number.MAX_SAFE_INTEGER
      : Number(options.max);
  const decimals = Number(options.decimals ?? 2);

  let current = Number(value);

  if (Number.isNaN(current)) {
    current = min;
  }

  current += event.key === 'ArrowUp' ? step : -step;
  current = Math.max(min, current);
  current = Math.min(max, current);

  return Number(current.toFixed(decimals));
}

export function formatNumber(value, decimals = 2) {
  if (value === null || value === undefined || value === '') return value;

  const num = Number(value);
  if (Number.isNaN(num)) return value;

  return Number.isInteger(num) ? num : num.toFixed(decimals);
}

export function toAbbreviation(text) {
  if (!text) return;

  return text
    .trim()
    .split(/\s+/)
    .filter(Boolean)
    .map((word) => word[0].toUpperCase())
    .join('');
}
